<div class="bid">
  <button type="button" class="bid__close" (click)="onCancelled()">
    <i class="material-icons">close</i>
  </button>
  <div class="bid__wrap">
    <booking-internal
      [event]="event"
      [embedded]="true"
      [prefill]="prefill"
      [relatedRecord]="relatedRecord"
      [recordType]="recordType"
      [bookingToReschedule]="bookingToReschedule"
      (bookingComplete)="onBookingComplete($event)"
      (cancelled)="onCancelled()">
    </booking-internal>
  </div>
</div>
